"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainAside = exports.MainAsideDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_full_screen_state_1 = require("../../hooks/use-full-screen-state");
exports.MainAsideDefaultProps = {
  asideRatio: 1 / 3,
  space: 3
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    ", "\n  "], ["\n    display: flex;\n    ", "\n  "])), function (props) {
    return props.isFullScreen && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      flex-direction: column;\n    "], ["\n      flex-direction: column;\n    "])));
  })
});
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    box-sizing: border-box;\n  "], ["\n    box-sizing: border-box;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\n    ", "\n\n    ", "\n  "], ["\n\n    ", "\n\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      margin-right: ", ";\n      width: calc(", "% - ", ");\n    "], ["\n      margin-right: ", ";\n      width: calc(", "% - ", ");\n    "])), theme_1.theme.UNIT(props.space), 100 * props.ratio, theme_1.theme.UNIT(props.space));
  }, function (props) {
    return props.isFullScreen && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      padding: ", ";\n      width: 100%;\n    "], ["\n      padding: ", ";\n      width: 100%;\n    "])), theme_1.theme.UNIT(5));
  })
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    box-sizing: border-box;\n  "], ["\n    box-sizing: border-box;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", "\n\n    ", "\n  "], ["\n    ", "\n\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      width: calc(", "%);\n    "], ["\n      width: calc(", "%);\n    "])), 100 * props.ratio);
  }, function (props) {
    return props.isFullScreen && (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      width: 100%;\n      padding: ", ";\n    "], ["\n      width: 100%;\n      padding: ", ";\n    "])), theme_1.theme.UNIT(5));
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Main: styled_components_1.default.section(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled_components_1.default.aside(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles)
};
var MainAside = function (props) {
  var className = props.className,
    id = props.id,
    children = props.children,
    main = props.main,
    aside = props.aside,
    asideRatio = props.asideRatio;
  var isFullScreen = (0, use_full_screen_state_1.useFullScreenState)().isFullScreen;
  var mainRatio = aside ? 1 - asideRatio : 1;
  var space = aside ? props.space : 0;
  return React.createElement(My.Container, {
    isFullScreen: isFullScreen,
    id: id,
    className: className
  }, React.createElement(My.Main, {
    space: space,
    hasAside: !!aside,
    ratio: mainRatio,
    isFullScreen: isFullScreen
  }, main || children), aside && React.createElement(My.Aside, {
    ratio: asideRatio,
    isFullScreen: isFullScreen
  }, aside));
};
exports.MainAside = MainAside;
exports.MainAside.defaultProps = exports.MainAsideDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;